export default function IconEnable() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.9999 7.08333H14.1666V5.41667C14.1666 3.11667 12.2999 1.25 9.99992 1.25C7.69992 1.25 5.83325 3.11667 5.83325 5.41667V7.08333H4.99992C4.08325 7.08333 3.33325 7.83333 3.33325 8.75V17.0833C3.33325 18 4.08325 18.75 4.99992 18.75H14.9999C15.9166 18.75 16.6666 18 16.6666 17.0833V8.75C16.6666 7.83333 15.9166 7.08333 14.9999 7.08333ZM7.49992 5.41667C7.49992 4.03333 8.61659 2.91667 9.99992 2.91667C11.3833 2.91667 12.4999 4.03333 12.4999 5.41667V7.08333H7.49992V5.41667ZM14.9999 17.0833H4.99992V8.75H14.9999V17.0833ZM9.99992 14.5833C10.9166 14.5833 11.6666 13.8333 11.6666 12.9167C11.6666 12 10.9166 11.25 9.99992 11.25C9.08325 11.25 8.33325 12 8.33325 12.9167C8.33325 13.8333 9.08325 14.5833 9.99992 14.5833Z'
        fill='#121212'
      />
    </svg>
  )
}
